import React from 'react'
import classnames from 'classnames'

import {AccordionItem} from './AccordionItem'
import {TAccordion} from './types'

import styles from './styles.module.css'

export function Accordion({data, className, stretchToFillContainer, accordionItemsProps, children}: TAccordion) {
  return (
    <div className={classnames(styles.accordionContainer, {[styles.stretch]: stretchToFillContainer}, className)}>
      {data &&
        data.length > 0 &&
        data.map((item, index) => <AccordionItem key={index.toString()} {...item} {...accordionItemsProps} />)}
      {children}
    </div>
  )
}
